"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestForQuoteLine = void 0;
const common_1 = require("../../common");
const models_1 = require("../../hr/models");
const models_2 = require("../../products/models");
const enums_1 = require("../enums");
const request_for_quote_header_model_1 = require("./request-for-quote-header.model");
class RequestForQuoteLine extends common_1.MongoDocument {
}
exports.RequestForQuoteLine = RequestForQuoteLine;
//# sourceMappingURL=request-for-quote-line.model.js.map